"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _commonI18n = require("@mmc/common-i18n");

var _reactRedux = require("react-redux");

var _configuratorSmallSummary = _interopRequireDefault(require("../styles/configurator-small-summary.css"));

var _configuratorSmallSummary2 = _interopRequireWildcard(require("./configurator-small-summary.props/configurator-small-summary.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import DEFAULT_PROPS from "./configurator-small-summary.props/configurator-small-summary.defaultProps";
var DEFAULT_PROPS = {};
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var renderIcon = function renderIcon(icon, value, theme) {
  return value ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].iconContainer
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: theme[icon] + " " + theme.lowIcon + " " + _configuratorSmallSummary["default"][icon]
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.bodyCopy + " " + _configuratorSmallSummary["default"].preferenceTag
  }, value)) : '';
};

var ToggleBar = function ToggleBar(_ref) {
  var data = _ref.data,
      hasFinance = _ref.hasFinance,
      financeAmount = _ref.financeAmount,
      financeSuffix = _ref.financeSuffix,
      toggleEvent = _ref.toggleEvent,
      isExpanded = _ref.isExpanded,
      nextButtonEvent = _ref.nextButtonEvent,
      nextStepLabel = _ref.nextStepLabel,
      config = _ref.config,
      stepId = _ref.stepId,
      fuelType = _ref.fuelType,
      driveType = _ref.driveType,
      transmissionType = _ref.transmissionType,
      theme = _ref.theme,
      disclaimerGroup = _ref.disclaimerGroup;
  var totalPriceValue = handleNestedProp(data, 'data.totalPrice.value');
  var zeroMessage = handleNestedProp(data, 'data.model.price.zeroMessage');
  var modelPriceValue = handleNestedProp(data, 'data.model.price.value');
  var toggleLabel = isExpanded ? data.hideSummary : data.viewSummary;
  var isFR = config.language === 'fr';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _configuratorSmallSummary["default"].toggleBar
  }, toggleLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6'] + " " + theme['col-sm-3'] + " " + theme['col-lg-2']
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    data: {
      priority: 'lowIcon',
      icon: 'ChevronDown',
      label: toggleLabel
    },
    classes: [_configuratorSmallSummary["default"].toggleBtn],
    theme: theme,
    clickEvent: toggleEvent
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].preferenceIconContainer + " " + theme['col-lg-8'] + " " + theme['col-sm-8'] + " " + theme['col-xs-12']
  }, renderIcon('mmcIconFuel', fuelType, theme), renderIcon('mmcIconFourWheelDrive', driveType, theme), renderIcon('mmcIconSteeringWheel', transmissionType, theme)), toggleLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].shortSummary + " " + theme['col-sm-5'] + " " + theme['col-lg-6']
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _configuratorSmallSummary["default"].shortSummaryHeader
  }, handleNestedProp(data, 'data.vehicle.name'), ' ', handleNestedProp(data, 'data.model.name'), ' ', totalPriceValue !== ' ' && totalPriceValue !== null && totalPriceValue > 0 && modelPriceValue > 0 && /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: modelPriceValue === 0 ? modelPriceValue : totalPriceValue,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      zeroMessage: zeroMessage
    },
    addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
    priceDisclaimerId: disclaimerGroup.msrpDisclaimerId,
    disclaimerData: disclaimerGroup.disclaimerData
  }), hasFinance && financeAmount !== null && financeAmount > 0 && config && (config.market === 'us' || config.market === 'ca') && /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorSmallSummary["default"].leaseAm
  }, isFR ? ' ou ' : ' or ', /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: hasFinance === 0 ? financeAmount : financeAmount,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      zeroMessage: zeroMessage
    },
    addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
    priceDisclaimerId: disclaimerGroup.monthlyMsrpDisclaimerId,
    disclaimerData: disclaimerGroup.disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorSmallSummary["default"].leaseAmSuffix
  }, financeSuffix)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme[toggleLabel ? 'col-xs-6' : 'col-xs-12'] + " " + theme['col-sm-4'] + " " + theme['col-lg-4'] + " " + _configuratorSmallSummary["default"].toggleHolder
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: nextButtonEvent,
    "data-step-id": stepId,
    className: _configuratorSmallSummary["default"].nextBtn + " " + theme.high,
    type: "button"
  }, data.nextButton, /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorSmallSummary["default"].colonSpacer
  }, data.nextButton.includes(':') ? ' ' : ': '), /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorSmallSummary["default"].btnStepLabel
  }, nextStepLabel))));
};

ToggleBar.displayName = 'ToggleBar';
ToggleBar.defaultProps = {
  data: DEFAULT_PROPS,
  config: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config,
    fuelType: state.fuelType.value,
    driveType: state.driveType.value,
    transmissionType: state.transmissionType.value
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ToggleBar);

exports["default"] = _default;